import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplateFileFetchFailedAction = {
	type: 'DOCUMENT_TEMPLATE_FILE_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplateFileFetchFailedAction => ({
	type: 'DOCUMENT_TEMPLATE_FILE_FETCH_FAILED',
	payload,
});
